var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockReverse = function SvgClockReverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a6 6 0 0 0-6 6H0l2.667 2.66L5.333 6h-2A4.663 4.663 0 0 1 8 1.333 4.663 4.663 0 0 1 12.667 6 4.663 4.663 0 0 1 8 10.667a4.63 4.63 0 0 1-3.293-1.374l-.947.947A5.97 5.97 0 0 0 8 12 6 6 0 0 0 8 0m-.667 3.333v3.334l2.834 1.68.513-.854L8.333 6.1V3.333z"
  })));
};
export default SvgClockReverse;